import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import SelectInput from "../../widgets/SelectInput";
import FixButton from "../../widgets/Button";
import getTag from "../../services/getTag";
import getCategorieTag from "../../services/getCategorieTag";
import getLeads from "../../services/getLeads";
import updateLeads from "../../services/updateLeads";
import addLeadsNote from "../../services/addLeadsNote";
import addLeadsCalls from "../../services/addLeadsCalls";
import Modal from "../../widgets/Modal";
import getLeadsNote from "../../services/getLeadsNote";
import getLeadsCalls from "../../services/getLeadsCalls";
import deleteLeadsNote from "../../services/deleteLeadsNote";
import deleteLeadsChiamata from "../../services/deleteLeadsChiamata";
import aggiornaIscritto from "../../services/aggiornaIscritto";
import getCorsi from "../../services/getCorsi";
import setLeadVisto from "../../services/setLeadVisto";
import { Call, EventNote as NoteIcon, Delete } from "@material-ui/icons";
import { max } from "moment";

export default class EditLead extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      studente: {
        id: null,
        nome: "",
        cognome: "",
        mail: "",
        telefono: "",
        dataModifica: null,
        dataUltimoContatto: null,
        dataIscrizione: "",
        eta: "",
        citta: "",
        idCorso: null,
      },
      tags: [],
      categorieTagOptions: [],
      selectedTagsByCategory: {},
      corsi: [],
      selectedCorso: null,
      isMobile: window.innerWidth < 663,
      note: "",
      dataOra: "",
      callDetails: "",
      callDataOra: "",
      isNotaModalOpen: false,
      isChiamataModalOpen: false,
    };
  }

  async componentDidMount() {
    await this.fetchData();
    await this.markLeadAsRead();

    window.addEventListener("resize", this.handleResize);
  }

  markLeadAsRead = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCrm = cookies.get("currentCrm", { path: "/" });

    if (currentCrm) {
      try {
        await setLeadVisto(username, token, currentCrm);
      } catch (error) {
        console.error("Errore nel segnare il lead come visto:", error);
      }
    }
  };

  fetchData = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCrm = cookies.get("currentCrm", { path: "/" });

    const leads = await getLeads(username, token);
    this.currentCrm = leads.find((lead) => lead.id == currentCrm);

    const tags = await getTag(username, token);
    const categorieTag = await getCategorieTag(username, token);
    const corsi = await getCorsi(username, token);

    console.log("Corsi caricati:", corsi);

    let allLeadsNote = [];
    let allLeadsCalls = [];

    try {
      allLeadsNote = await getLeadsNote(username, token);
      // Assicurati che sia un array
      if (!Array.isArray(allLeadsNote)) {
        console.warn("getLeadsNote non ha restituito un array:", allLeadsNote);
        allLeadsNote = [];
      }
    } catch (error) {
      console.error("Errore nel caricamento delle note lead:", error);
      allLeadsNote = [];
    }

    try {
      allLeadsCalls = await getLeadsCalls(username, token);
      // Assicurati che sia un array
      if (!Array.isArray(allLeadsCalls)) {
        console.warn(
          "getLeadsCalls non ha restituito un array:",
          allLeadsCalls
        );
        allLeadsCalls = [];
      }
    } catch (error) {
      console.error("Errore nel caricamento delle chiamate lead:", error);
      allLeadsCalls = [];
    }

    const tagIds = this.currentCrm.tag_id
      ? this.currentCrm.tag_id.split(",")
      : [];
    const selectedTagsByCategory = {};
    tagIds.forEach((id) => {
      const tag = tags.find((tag) => tag.id == id);
      if (tag) {
        const categoriaId = tag.id_categoria;
        if (!selectedTagsByCategory[categoriaId])
          selectedTagsByCategory[categoriaId] = [];
        selectedTagsByCategory[categoriaId].push({
          value: tag.id,
          label: tag.tag,
        });
      }
    });

    const findLeadsNote = allLeadsNote.filter(
      (lead) => lead.id_lead == this.currentCrm.id
    );
    const leadsNote = findLeadsNote.map((lead) => ({
      id: lead.id,
      note: decodeURIComponent(lead.note || ""),
      dataOra: lead.data_ora,
      type: "leadsNote",
    }));

    const findLeadsCalls = allLeadsCalls.filter(
      (lead) => lead.id_lead == this.currentCrm.id
    );
    const leadsCalls = findLeadsCalls.map((lead) => ({
      id: lead.id,
      note: decodeURIComponent(lead.note || ""),
      dataOra: lead.data_ora,
      type: "leadsCalls",
    }));

    const note = [...leadsNote, ...leadsCalls];

    // Trova il corso selezionato se presente
    let selectedCorso = null;
    if (this.currentCrm.id_corso && corsi.length > 0) {
      const corso = corsi.find((c) => c.id == this.currentCrm.id_corso);
      if (corso) {
        selectedCorso = {
          value: corso.id,
          label: corso.name || corso.nome,
        };
      }
    }

    this.setState({
      categorieTagOptions: categorieTag,
      tags,
      corsi,
      selectedCorso,
      studente: {
        id: this.currentCrm.id,
        nome: this.currentCrm.nome,
        cognome: this.currentCrm.cognome,
        mail: this.currentCrm.mail,
        telefono: this.currentCrm.telefono,
        prenotazione: this.currentCrm.prenotazione,
        dataModifica: this.currentCrm.data_modifica,
        dataUltimoContatto: this.currentCrm.data_ultimo_contatto,
        dataIscrizione: this.currentCrm.data_iscrizione || "",
        eta: this.currentCrm.eta || "",
        citta: this.currentCrm.citta || "",
        idCorso: this.currentCrm.id_corso || null,
      },
      selectedTagsByCategory,
      allNote: note,
    });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 663 });
  };

  handleTagChange = (categoriaId, selectedOptions) => {
    this.setState((prevState) => {
      const previousTags = prevState.selectedTagsByCategory[categoriaId] || [];
      const newOptions = selectedOptions || [];
      const isAddingTag = newOptions.length > previousTags.length;

      if (categoriaId === 1 && isAddingTag) {
        alert("Prima di salvare aggiungi registra chiamata");
      }

      // Verifica se è stato aggiunto il tag "ISCRITTO"
      if (isAddingTag) {
        const newTag = newOptions.find(
          (tag) => !previousTags.some((prevTag) => prevTag.value === tag.value)
        );

        if (newTag) {
          const tagInfo = this.state.tags.find((t) => t.id == newTag.value);

          // Controlla se il tag aggiunto è "ISCRITTO"
          if (tagInfo && tagInfo.tag.toUpperCase() === "ISCRITTO") {
            // Chiama l'API per aggiornare lo stato iscritto
            const cookies = new Cookies();
            const username = cookies.get("username", { path: "/" });
            const token = cookies.get("token", { path: "/" });
            const email = prevState.studente.mail;
            const idCorso = prevState.studente.idCorso;

            if (email && username && token) {
              aggiornaIscritto(username, token, email, true, idCorso)
                .then((response) => {
                  console.log(
                    "Stato iscritto aggiornato con successo:",
                    response
                  );
                  alert(
                    "Contatto aggiornato come iscritto nel sistema di tracking!"
                  );
                })
                .catch((error) => {
                  console.error(
                    "Errore nell'aggiornamento dello stato iscritto:",
                    error
                  );
                  alert(
                    "Attenzione: errore nell'aggiornamento del sistema di tracking.\n" +
                      "Errore: " +
                      error.message
                  );
                });
            } else {
              alert(
                "Impossibile aggiornare lo stato iscritto: dati mancanti (email, username o token)."
              );
            }
          }
        }
      }

      const updatedSelectedTagsByCategory = {
        ...prevState.selectedTagsByCategory,
        [categoriaId]: newOptions,
      };

      return { selectedTagsByCategory: updatedSelectedTagsByCategory };
    });
  };

  handleCorsoChange = (selectedOption) => {
    this.setState((prevState) => ({
      selectedCorso: selectedOption,
      studente: {
        ...prevState.studente,
        idCorso: selectedOption ? selectedOption.value : null,
      },
    }));
  };

  handleNoteChange = (e) => {
    const { value } = e.target;
    this.setState({ note: value });
  };

  handleDataOraChange = (e) => {
    const { value } = e.target;
    const yearMatch = value.match(/^(\d{4})-/);
    if (!yearMatch) {
      alert("Per favore, inserisci una data valida con un anno a 4 cifre.");
    } else {
      this.setState({ dataOra: value });
    }
  };

  handleCallDetailsChange = (e) => {
    const { value } = e.target;
    this.setState({ callDetails: value });
  };

  handleCallDataOraChange = (e) => {
    const { value } = e.target;
    const yearMatch = value.match(/^(\d{4})-/);
    if (!yearMatch) {
      alert("Per favore, inserisci una data valida con un anno a 4 cifre.");
    } else {
      this.setState({ callDataOra: value });
    }
  };

  toggleModal = (modalType) => {
    this.setState((prevState) => ({
      [modalType]: !prevState[modalType],
      ...(modalType === "isNotaModalOpen" || modalType === "isChiamataModalOpen"
        ? { dataOra: "", callDetails: "", callDataOra: "" }
        : {}),
    }));
  };

  onSaveNota = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const { studente, note, dataOra } = this.state;

    const finalDataOra = dataOra || new Date().toISOString().slice(0, 16);

    if (!note || !finalDataOra) {
      alert("Per favore, riempi tutti i campi.");
      return;
    }

    try {
      await addLeadsNote(username, token, studente.id, note, finalDataOra);
      alert("Aggiunto con successo!");
      this.setState({ note: "", dataOra: "", isNotaModalOpen: false });

      // Salva le modifiche locali prima di ricaricare i dati
      const currentStudenteData = this.state.studente;
      const currentSelectedTags = this.state.selectedTagsByCategory;

      await this.fetchData();

      // Ripristina le modifiche locali dopo il ricaricamento
      this.setState({
        studente: currentStudenteData,
        selectedTagsByCategory: currentSelectedTags,
      });
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  };

  onSaveChiamata = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const { studente, callDetails, callDataOra } = this.state;

    const finalDataOra = callDataOra || new Date().toISOString().slice(0, 16);

    if (!callDetails || !finalDataOra) {
      alert("Per favore, riempi tutti i campi.");
      return;
    }

    try {
      await addLeadsCalls(
        username,
        token,
        studente.id,
        callDetails,
        finalDataOra
      );
      alert("Aggiunto con successo!");
      this.setState({
        callDetails: "",
        callDataOra: "",
        isChiamataModalOpen: false,
      });

      // Salva le modifiche locali prima di ricaricare i dati
      const currentStudenteData = this.state.studente;
      const currentSelectedTags = this.state.selectedTagsByCategory;

      await this.fetchData();

      // Ripristina le modifiche locali dopo il ricaricamento
      this.setState({
        studente: currentStudenteData,
        selectedTagsByCategory: currentSelectedTags,
      });
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  };

  onDeleteNota = async (id) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questa nota?"
    );

    if (!confirmDelete) {
      return;
    }

    try {
      await deleteLeadsNote(username, token, id);
      alert("Eliminato con successo!");

      // Salva le modifiche locali prima di ricaricare i dati
      const currentStudenteData = this.state.studente;
      const currentSelectedTags = this.state.selectedTagsByCategory;

      await this.fetchData();

      // Ripristina le modifiche locali dopo il ricaricamento
      this.setState({
        studente: currentStudenteData,
        selectedTagsByCategory: currentSelectedTags,
      });
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  };

  onDeleteChiamata = async (id) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questa chiamata?"
    );

    if (!confirmDelete) {
      return;
    }

    try {
      await deleteLeadsChiamata(username, token, id);
      alert("Eliminato con successo!");

      // Salva le modifiche locali prima di ricaricare i dati
      const currentStudenteData = this.state.studente;
      const currentSelectedTags = this.state.selectedTagsByCategory;

      await this.fetchData();

      // Ripristina le modifiche locali dopo il ricaricamento
      this.setState({
        studente: currentStudenteData,
        selectedTagsByCategory: currentSelectedTags,
      });
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  };

  render() {
    const {
      studente,
      categorieTagOptions,
      tags,
      selectedTagsByCategory,
      isLoading,
      allNote,
      dataOra,
    } = this.state;

    const tagsByCategory = categorieTagOptions.map((categoria) => {
      const tagsForCategory = tags.filter(
        (tag) => tag.id_categoria === categoria.id
      );
      return {
        ...categoria,
        tags: tagsForCategory,
      };
    });

    const getFilteredTags = (categoriaId) => {
      const selectedTagsInOtherCategories = Object.values(
        selectedTagsByCategory || {}
      )
        .flat()
        .filter((tag) => tag && tag.value)
        .map((tag) => tag.value);
      return tagsByCategory
        .find((categoria) => categoria.id === categoriaId)
        .tags.filter((tag) => !selectedTagsInOtherCategories.includes(tag.id));
    };

    const formGridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 2fr",
      gap: "16px",
    };

    const responsiveGridStyle = (width) => ({
      ...formGridStyle,
      gridTemplateColumns: width > 686 ? "1fr 2fr" : "1fr",
    });

    const formItemStyle = {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    };

    const tagButtonStyle = (baseColor) => ({
      display: "flex",
      flexDirection: "column",
      padding: "8px 12px",
      fontSize: "14px",
      fontWeight: "bold",
      color: "white",
      backgroundColor: baseColor,
      border: "none",
      borderRadius: "16px",
      transition: "background-color 0.3s ease",
      maxWidth: "700px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "pre-wrap",
    });

    const noteStyle = {
      fontSize: "12px",
      fontWeight: "normal",
      color: "rgba(255, 255, 255)",
    };
    console.log("tagsByCategory", tagsByCategory);
    return (
      <LoadingOverlay
        active={isLoading}
        spinner
        text={"Loading your content..."}
      >
        <PageTitle title="Modifica Lead" />

        {studente.dataModifica && (
          <div
            style={{
              marginBottom: "20px",
              padding: "10px",
              backgroundColor: "#f5f5f5",
              borderRadius: "5px",
              fontSize: "14px",
              color: "#666",
            }}
          >
            <div style={{ marginBottom: "5px" }}>
              <strong>Data ultima modifica:</strong>{" "}
              {new Date(studente.dataModifica).toLocaleString("it-IT")}
            </div>
            {studente.dataUltimoContatto && (
              <div>
                <strong>Data ultimo contatto:</strong>{" "}
                {new Date(studente.dataUltimoContatto).toLocaleString("it-IT")}
              </div>
            )}
          </div>
        )}

        <div style={responsiveGridStyle(window.innerWidth)}>
          <div style={formItemStyle}>
            <TextInput
              name={"Nome"}
              value={studente.nome}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, nome: text },
                }))
              }
            />
            <TextInput
              name={"Cognome"}
              value={studente.cognome}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, cognome: text },
                }))
              }
            />
            <TextInput
              name={"Email"}
              value={studente.mail}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, mail: text },
                }))
              }
            />
            <TextInput
              name={"Telefono"}
              value={studente.telefono}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, telefono: text },
                }))
              }
            />
            <TextInput
              name={"Età"}
              value={studente.eta}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, eta: text },
                }))
              }
            />
            <TextInput
              name={"Città"}
              value={studente.citta}
              onChange={(text) =>
                this.setState((prevState) => ({
                  studente: { ...prevState.studente, citta: text },
                }))
              }
            />
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <label style={{ fontSize: "14px", fontWeight: "bold" }}>
                Data iscrizione
              </label>
              <input
                type="date"
                value={studente.dataIscrizione || ""}
                onChange={(e) => {
                  const value = e?.target?.value || "";
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      dataIscrizione: value,
                    },
                  }));
                }}
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                }}
              />
            </div>
          </div>

          <div style={formItemStyle}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {tagsByCategory
                .sort((a, b) => a.id - b.id)
                .map((categoria) => (
                  <div
                    key={categoria.id}
                    style={{
                      flex: "1 1 calc(50% - 16px)",
                    }}
                  >
                    <SelectInput
                      value={selectedTagsByCategory[categoria.id] || []}
                      name={categoria.nome}
                      hidable={false}
                      options={getFilteredTags(categoria.id).map((tag) => ({
                        value: tag.id,
                        label: tag.tag,
                      }))}
                      isMulti={true}
                      onChange={(selectedOptions) =>
                        this.handleTagChange(categoria.id, selectedOptions)
                      }
                    />
                  </div>
                ))}
              <TextInput
                name={"Prenotazione chiamata"}
                value={studente.prenotazione}
                onChange={(text) =>
                  this.setState((prevState) => ({
                    studente: { ...prevState.studente, prenotazione: text },
                  }))
                }
              />
            </div>
            <SelectInput
              value={this.state.selectedCorso}
              name={"CORSO ISCRITTO"}
              hidable={false}
              options={this.state.corsi.map((corso) => ({
                value: corso.id,
                label: corso.name || corso.nome,
              }))}
              isMulti={false}
              onChange={this.handleCorsoChange}
            />
          </div>
        </div>
        {allNote && allNote.length > 0 && (
          <>
            <p>Note</p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              {allNote.map((item, index) => (
                <div
                  key={index}
                  style={tagButtonStyle(
                    item.type === "leadsNote" ? "#3498db" : "#27ae60"
                  )}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {item.type === "leadsCalls" ? (
                      <Call style={{ fontSize: "22px", marginBottom: "5px" }} />
                    ) : (
                      <NoteIcon
                        style={{ fontSize: "22px", marginBottom: "5px" }}
                      />
                    )}
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        item.type === "leadsNote"
                          ? this.onDeleteNota(item.id)
                          : this.onDeleteChiamata(item.id)
                      }
                    >
                      <Delete
                        style={{
                          fontSize: "22px",
                          marginBottom: "5px",
                          color: "rgba(255, 255, 255)",
                        }}
                      />
                    </button>
                  </div>
                  <span
                    style={{
                      textAlign: "left",
                      marginBottom: "5px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      width: "100%",
                    }}
                  >
                    {item.note}
                  </span>
                  <span style={noteStyle}>{item.dataOra}</span>
                </div>
              ))}
            </div>
          </>
        )}

        <PageTitle
          button={"REGISTRA CHIAMATA"}
          onClick={() => this.toggleModal("isChiamataModalOpen")}
          secondButton={"AGGIUNGI NOTA"}
          onSecondClick={() => this.toggleModal("isNotaModalOpen")}
        />

        {this.state.isNotaModalOpen && (
          <Modal
            title={"Note Leads"}
            noteValue={this.state.note}
            dataOra={this.state.dataOra}
            dataOraChange={this.handleDataOraChange}
            onNoteChange={this.handleNoteChange}
            note
            onClose={() => this.toggleModal("isNotaModalOpen")}
            isOpen={this.state.isNotaModalOpen}
            onConfirm={this.onSaveNota}
          />
        )}

        {this.state.isChiamataModalOpen && (
          <Modal
            title={"Registra chiamata"}
            noteValue={this.state.callDetails}
            dataOra={this.state.callDataOra}
            dataOraChange={this.handleCallDataOraChange}
            onNoteChange={this.handleCallDetailsChange}
            note
            onClose={() => this.toggleModal("isChiamataModalOpen")}
            isOpen={this.state.isChiamataModalOpen}
            onConfirm={this.onSaveChiamata}
          />
        )}

        <br />
        <FixButton title={"Salva"} callback={this.save.bind(this)} />
      </LoadingOverlay>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const userType = cookies.get("userType", { path: "/" });

    const { studente, selectedTagsByCategory } = this.state;

    // ✅ Controllo BLOCCANTE duplicati prima di salvare
    try {
      const existingLeads = await getLeads(username, token);

      // Verifica duplicati per telefono (escludendo il lead corrente)
      const duplicateByPhone =
        studente.telefono &&
        existingLeads.find(
          (lead) =>
            lead.id != studente.id &&
            lead.telefono &&
            lead.telefono.trim() === studente.telefono.trim()
        );

      // Verifica duplicati per email (escludendo il lead corrente)
      const duplicateByEmail =
        studente.mail &&
        existingLeads.find(
          (lead) =>
            lead.id != studente.id &&
            lead.mail &&
            lead.mail.toLowerCase().trim() ===
              studente.mail.toLowerCase().trim()
        );

      if (duplicateByPhone || duplicateByEmail) {
        let errorMessage =
          "⚠️ IMPOSSIBILE SALVARE LE MODIFICHE\n\nEsiste già un altro lead con:\n";

        if (duplicateByPhone) {
          errorMessage += `\n• Telefono: "${studente.telefono}"`;
          errorMessage += `\n  Nome esistente: ${duplicateByPhone.nome ||
            ""} ${duplicateByPhone.cognome || ""}`;
        }

        if (duplicateByEmail) {
          errorMessage += `\n• Email: "${studente.mail}"`;
          errorMessage += `\n  Nome esistente: ${duplicateByEmail.nome ||
            ""} ${duplicateByEmail.cognome || ""}`;
        }

        errorMessage += "\n\n❌ MODIFICA I DATI PRIMA DI SALVARE";

        alert(errorMessage);
        return; // Blocca completamente il salvataggio
      }
    } catch (error) {
      console.error("Errore durante il controllo duplicati:", error);
      alert("Errore durante il controllo duplicati. Impossibile procedere.");
      return;
    }

    const tagIds = Object.values(selectedTagsByCategory)
      .flat()
      .filter((tag) => tag && tag.value)
      .map((tag) => tag.value)
      .join(",");

    try {
      await updateLeads(
        username,
        token,
        studente.id,
        studente.cognome,
        studente.nome,
        studente.mail,
        tagIds,
        studente.telefono,
        studente.prenotazione,
        studente.dataIscrizione,
        studente.eta,
        studente.citta,
        studente.idCorso
      );

      alert("Aggiornato con successo!");

      if (userType == 4) return (window.location.href = "/#/app/daChiamare");

      window.location.href = "/#/app/leads";
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  }
}
